export const API_BASE = process.env.REACT_APP_BACKEND_URL;

export const getToken = () => sessionStorage.getItem('jwtToken');

export const authHeaders = () => ({
  Authorization: `Bearer ${getToken()}`
});

export const toDateKey = (value) => {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const formatDateTime = (value) => {
  if (!value) return '-';
  try {
    return new Intl.DateTimeFormat('nl-NL', {
      dateStyle: 'medium',
      timeStyle: 'short'
    }).format(new Date(value));
  } catch {
    return value;
  }
};

export const formatTime = (value) => {
  if (!value) return '-';
  try {
    return new Intl.DateTimeFormat('nl-NL', {
      hour: '2-digit',
      minute: '2-digit'
    }).format(new Date(value));
  } catch {
    return value;
  }
};

export const statusLabel = (status) => {
  const normalized = String(status || '').toLowerCase();
  const labels = {
    requested: 'Aangevraagd',
    planned: 'Gepland',
    confirmed: 'Akkoord',
    cancelled: 'Geannuleerd',
    completed: 'Afgerond',
    no_show: 'No-show',
    rescheduled: 'Verplaatst'
  };
  return labels[normalized] || status || '-';
};

export const statusBadgeClass = (status) => {
  const normalized = String(status || '').toLowerCase();
  if (normalized === 'confirmed') return 'badge bg-success';
  if (normalized === 'requested') return 'badge bg-warning text-dark';
  if (normalized === 'planned') return 'badge bg-info text-dark';
  if (normalized === 'cancelled') return 'badge bg-secondary';
  if (normalized === 'completed') return 'badge bg-primary';
  if (normalized === 'no_show') return 'badge bg-danger';
  return 'badge bg-light text-dark border';
};

export const canParentChangeLesson = (lesson) => {
  const status = String(lesson?.status || lesson?.planner_status || '').toLowerCase();
  if (!['requested', 'planned', 'confirmed'].includes(status)) return false;
  if (!lesson?.start_at) return false;
  const diffHours = (new Date(lesson.start_at).getTime() - Date.now()) / (1000 * 60 * 60);
  return diffHours >= 24;
};

export const getMonthLabel = (date) => {
  try {
    return new Intl.DateTimeFormat('nl-NL', {
      month: 'long',
      year: 'numeric'
    }).format(date);
  } catch {
    return '';
  }
};

export const buildCalendarDays = (currentMonth) => {
  const year = currentMonth.getFullYear();
  const month = currentMonth.getMonth();
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const firstDayJs = firstDay.getDay();
  const mondayBasedOffset = firstDayJs === 0 ? 6 : firstDayJs - 1;
  const days = [];

  for (let i = 0; i < mondayBasedOffset; i += 1) days.push(null);
  for (let day = 1; day <= lastDay.getDate(); day += 1) days.push(new Date(year, month, day));

  return days;
};
